module.exports = __webpack_public_path__ + "static/media/chevron-down-solid.aefc7a7b.svg";